import React, { Component } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    IconButton,
    Button,
    Grid,
    MenuItem,
    Collapse,
    Switch,
    Divider
} from '@mui/material';
import {
    Add as AddIcon,
    Close as CloseIcon,
    InventoryOutlined as InventoryIcon,
    CollectionsOutlined as CollectionsIcon,
    KeyboardArrowDown as ArrowDownIcon,
    KeyboardArrowUp as ArrowUpIcon
} from '@mui/icons-material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { apiUrl } from '../../comp/ApiUrl';
import { WithRouter } from '../../comp/WithRouter';
import { toast } from 'react-toastify';
import VariacoesProduto from '../../comp/VariacoesProduto';
class EditarProduto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Bloco de Fotos
            fotos: [],
            categorias: [],
            // Bloco de Informações Básicas
            nome: '',
            descricao: '',
            categoria: '',
            subcategoria: '',
            marca: '',
            sku: '',
            destaque: 'Nenhum',

            // Controle de interface do sanfonado (Collapse)
            expandidoOpcional: false,
            precoVenda: '',
            precoOriginal: '',
            precoSobConsulta: false, // Começa ativo como na imagem

            // Configurar preço de atacado
            expandidoAtacado: false, // Controla o colapso do bloco de atacado
            venderAtacado: true,    // Chave "Vender no atacado?"
            exibirApenasAtacado: false, // Chave "Exibir apenas preço de atacado"
            precoAtacado: '',
            qtdMinima: 3,
            unidade: 'UN',

            // Bloco de Variações
            variacoes: [],
        };
        this.fileInputRef = React.createRef();
    }

    componentDidMount() {
        document.title = 'Editar Produto';
        fetch(`${apiUrl}/produtos/editar/${this.props.params.uuid}`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => {
            if (response.status == 200) {
                response.json().then((data) => {
                    console.log(data)
                    this.setState({


                    })
                });
            }
        })
            .catch((error) => {
                console.error("Erro ao buscar produtos", error);
            })
    }
    // Transforma a string do input (ex: "R$ 7,50") em um número puro (ex: 7.5)
    stringToNumber = (value) => {
        if (!value) return 0;

        // Remove tudo que não for dígito
        const cleanValue = value.replace(/\D/g, "");

        // Transforma em centavos (ex: "750" vira 7.50)
        return parseFloat(cleanValue) / 100;
    };

    // Transforma o número do estado (ex: 7.5) em string formatada (ex: "R$ 7,50")
    numberToBRL = (value) => {
        if (value === undefined || value === null || isNaN(value)) return "";

        return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        }).format(value);
    };
    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };
    handleSwitchChange = (event) => {
        const { name, checked } = event.target;
        this.setState({ [name]: checked });
    };
    toggleOpcionais = () => {
        this.setState((prevState) => ({ expandidoOpcional: !prevState.expandidoOpcional }));
    };

    handleRemoverFoto = (id) => {
        this.setState((prevState) => {
            const novasFotos = prevState.fotos.filter((foto) => foto.id !== id);
            const tinhaPrincipal = prevState.fotos.find(f => f.id === id)?.principal;
            if (tinhaPrincipal && novasFotos.length > 0) {
                novasFotos[0].principal = true;
            }
            return { fotos: novasFotos };
        });
    };

    handleFileChange = async (event) => {
        const files = Array.from(event.target.files);
        if (files.length === 0) return;

        // 1. Criamos um FormData para enviar os arquivos binários ao servidor
        const formData = new FormData();
        files.forEach((file) => {
            formData.append("images", file);
        });

        try {
            // Exibe um toast de carregamento opcional para dar feedback ao usuário
            const toastId = toast.loading("Enviando imagens...");

            // 2. Fazemos o upload para a rota específica de imagens
            const response = await fetch(`${apiUrl}/products/upload-images/${this.props.params.uuid}`, {
                method: "POST",
                credentials: "include",
                body: formData, // O navegador define o Content-Type como multipart/form-data automaticamente
            });

            const data = await response.json();

            // 🔴 ATUALIZADO: Verificamos se o servidor retornou 'imagens' com sucesso
            if (data.success && data.imagens) {
                toast.update(toastId, { render: "Imagens enviadas com sucesso!", type: "success", isLoading: false, autoClose: 3000 });

                // 3. Atualizamos o estado usando o ID real do MySQL e o NAME convertido
                this.setState((prevState) => {
                    const novasFotos = data.imagens.map((img, index) => ({
                        id: img.id, // 🔴 ATUALIZADO: ID real gerado pelo MySQL (AUTO_INCREMENT)
                        name: img.name, // Nome do arquivo .webp gravado no servidor
                        url: `${img.name}`, // 🔴 ATUALIZADO: Caminho completo para renderizar a imagem na tela
                        principal: prevState.fotos.length === 0 && index === 0 // Define a primeira como principal se a lista estiver vazia
                    }));
                    return { fotos: [...prevState.fotos, ...novasFotos] };
                });
            } else {
                toast.update(toastId, { render: data.error || "Erro ao subir imagens.", type: "error", isLoading: false, autoClose: 3000 });
            }
        } catch (error) {
            console.error("Erro no upload de fotos:", error);
            toast.error("Erro de conexão ao enviar imagens.");
        }

        event.target.value = ''; // Limpa o input para permitir selecionar o mesmo arquivo novamente
    };

    triggerFileSelect = () => {
        this.fileInputRef.current.click();
    };

    render() {
        const {
            nome,
            descricao,
            fotos,
            categoria,
            categorias,
            subcategoria,
            marca,
            sku,
            destaque,
            expandidoOpcional,
            precoVenda,
            precoOriginal,
            precoSobConsulta,
            expandidoAtacado,
            venderAtacado,
            exibirApenasAtacado,
            precoAtacado,
            qtdMinima,
            unidade
        } = this.state;

        // Estilo padrão compartilhado para os inputs cinzas e arredondados do layout
        const inputStyle = {
            '& .MuiOutlinedInput-root': {
                backgroundColor: '#f8fafc',
                borderRadius: 2,
                '& fieldset': { borderColor: '#e2e8f0' },
                '&:hover fieldset': { borderColor: '#cbd5e1' },
                '&.Mui-focused fieldset': { borderColor: '#9966f1' }
            },
            '& .MuiOutlinedInput-input::placeholder': {
                color: '#94a3b8',
                opacity: 1
            }
        };

        return (
            <Box sx={{ p: 0, backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                <input
                    type="file"
                    multiple
                    accept="image/*"
                    ref={this.fileInputRef}
                    style={{ display: 'none' }}
                    onChange={this.handleFileChange}
                />

                {/* ================= BLOCO 1: FOTOS DO PRODUTO ================= */}
                <Card sx={{ mb: 3, borderRadius: 3, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)', border: '1px solid #e2e8f0' }}>
                    <CardContent sx={{ p: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                            <Box sx={{ bgcolor: '#f3e5f5', p: 1, borderRadius: 2, display: 'flex' }}>
                                <CollectionsIcon sx={{ color: '#9c27b0' }} />
                            </Box>
                            <Box>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                                    Fotos do produto
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                    {fotos.length} {fotos.length === 1 ? 'foto adicionada' : 'fotos adicionadas'}
                                </Typography>
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                            {fotos.map((foto) => (
                                <Box
                                    key={foto.id}
                                    sx={{
                                        width: 140,
                                        height: 140,
                                        position: 'relative',
                                        borderRadius: 2,
                                        border: '1px solid #e2e8f0',
                                        backgroundImage: `url(${apiUrl}/static/${foto.url})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <IconButton
                                        size="small"
                                        onClick={() => this.handleRemoverFoto(foto.id)}
                                        sx={{
                                            position: 'absolute',
                                            top: 4,
                                            right: 4,
                                            backgroundColor: '#ef4444',
                                            color: 'white',
                                            width: 20,
                                            height: 20,
                                            '&:hover': { backgroundColor: '#dc2626' }
                                        }}
                                    >
                                        <CloseIcon sx={{ fontSize: 14 }} />
                                    </IconButton>

                                    {foto.principal && (
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                                color: 'white',
                                                textAlign: 'center',
                                                py: 0.5,
                                                fontSize: '11px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Principal
                                        </Box>
                                    )}
                                </Box>
                            ))}

                            <Box
                                onClick={this.triggerFileSelect}
                                sx={{
                                    width: 140,
                                    height: 140,
                                    border: '2px dashed #cbd5e1',
                                    borderRadius: 2,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    backgroundColor: '#fff',
                                    transition: 'all 0.2s',
                                    '&:hover': { borderColor: '#7c3aed', backgroundColor: '#f8f5ff' }
                                }}
                            >
                                <AddIcon sx={{ color: '#64748b', fontSize: 28, mb: 0.5 }} />
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 500 }}>
                                    Adicionar
                                </Typography>
                            </Box>
                        </Box>

                        <Button
                            variant="text"
                            size="small"
                            disabled
                            startIcon={<AddIcon sx={{ fontSize: 14 }} />}
                            sx={{ mt: 2, textTransform: 'none', color: '#4f46e5', fontWeight: 'bold' }}
                        >
                            Adicionar por link
                        </Button>
                    </CardContent>
                </Card>

                {/* ================= BLOCO 2: INFORMAÇÕES BÁSICAS ================= */}
                <Card sx={{ borderRadius: 3, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)', border: '1px solid #e2e8f0' }}>
                    <CardContent sx={{ p: 3 }}>

                        {/* Header do Card */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                            <Box sx={{ bgcolor: '#f3e5f5', p: 1, borderRadius: 2, display: 'flex' }}>
                                <InventoryIcon sx={{ color: '#9c27b0' }} />
                            </Box>
                            <Box>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                                    Informações básicas
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                    Nome, descrição e categoria
                                </Typography>
                            </Box>
                        </Box>

                        {/* Campo: Nome do produto */}
                        <Box sx={{ mb: 2.5 }}>
                            <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                Nome do produto <span style={{ color: '#ef4444' }}>*</span>
                            </Typography>
                            <TextField
                                fullWidth
                                name="nome"
                                value={nome}
                                onChange={this.handleInputChange}
                                placeholder="Ex: Vestido Floral Primavera"
                                variant="outlined"
                                size="small"
                                sx={inputStyle}
                            />
                        </Box>

                        {/* Campo: Descrição */}
                        <Box sx={{ mb: 2.5 }}>
                            <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                Descrição
                            </Typography>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                name="descricao"
                                value={descricao}
                                onChange={this.handleInputChange}
                                placeholder="Escreva os detalhes, tecido, medidas..."
                                variant="outlined"
                                size="small"
                                inputProps={{ maxLength: 1500 }}
                                sx={inputStyle}
                            />
                            <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5 }}>
                                {descricao.length}/1500
                            </Typography>
                        </Box>

                        {/* Grid: Categoria e Subcategoria */}
                        <Grid container spacing={2} sx={{ mb: 3 }}>
                            <Grid item size={{ xs: 12, md: 2 }}>
                                <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                    Categoria
                                </Typography>
                                <TextField
                                    select
                                    fullWidth
                                    name="categoria"
                                    value={categoria}
                                    onChange={this.handleInputChange}
                                    variant="outlined"
                                    size="small"
                                    displayEmpty
                                    sx={inputStyle}
                                >
                                    {categorias.map((categoria) => (
                                        <MenuItem key={categoria.id} value={categoria.id}>{categoria.nome}</MenuItem>
                                    ))}
                                </TextField>
                            </Grid>

                        </Grid>

                        {/* Seletor Desdobrável: Marca, código e destaque */}
                        <Box sx={{ mb: 1 }}>
                            <Button
                                onClick={this.toggleOpcionais}
                                startIcon={expandidoOpcional ? <ArrowUpIcon fontSize="small" /> : <ArrowDownIcon fontSize="small" />}
                                sx={{
                                    textTransform: 'none',
                                    color: '#64748b',
                                    fontWeight: '500',
                                    fontSize: '0.875rem',
                                    p: 0,
                                    '&:hover': { bgcolor: 'transparent', color: '#475569' }
                                }}
                            >
                                Marca, código e destaque (opcional)
                            </Button>
                        </Box>

                        <Collapse in={expandidoOpcional}>
                            <Grid container spacing={2} sx={{ mt: 0.5 }}>
                                {/* Campo: Marca */}
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        Marca
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        name="marca"
                                        value={marca}
                                        onChange={this.handleInputChange}
                                        placeholder="Ex: Nike"
                                        variant="outlined"
                                        size="small"
                                        sx={inputStyle}
                                    />
                                </Grid>

                                {/* Campo: Código/SKU */}
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        Código/SKU
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        name="sku"
                                        value={sku}
                                        onChange={this.handleInputChange}
                                        placeholder="Ex: SKU-123"
                                        variant="outlined"
                                        size="small"
                                        sx={inputStyle}
                                    />
                                </Grid>

                                {/* Campo: Destaque */}
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        Destaque
                                    </Typography>
                                    <TextField
                                        select
                                        fullWidth
                                        name="destaque"
                                        value={destaque}
                                        onChange={this.handleInputChange}
                                        variant="outlined"
                                        size="small"
                                        sx={inputStyle}
                                    >
                                        <MenuItem value="0" disabled>Nenhum</MenuItem>
                                        <MenuItem value="1">Novidade</MenuItem>
                                        <MenuItem value="2">Promoção</MenuItem>
                                        <MenuItem value="3">Mais Vendido</MenuItem>
                                        <MenuItem value="4">Últimas Unidades</MenuItem>
                                    </TextField>
                                </Grid>
                            </Grid>
                        </Collapse>

                    </CardContent>
                </Card>
                <Card sx={{ mt: 3, borderRadius: 3, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)', border: '1px solid #e2e8f0' }}>
                    <CardContent sx={{ p: 3 }}>

                        {/* Header do Card */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                            <Box sx={{ bgcolor: '#e8f5e9', p: 1, borderRadius: 2, display: 'flex' }}>
                                <AttachMoneyIcon sx={{ color: '#2e7d32' }} />
                            </Box>
                            <Box>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                                    Preço
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                    Sob consulta
                                </Typography>
                            </Box>
                        </Box>

                        {/* Linha 1: Preço de Venda e Preço Original */}
                        <Grid container spacing={2} sx={{ mb: 2.5 }}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                    Estoque <span style={{ color: '#ef4444' }}>*</span>
                                </Typography>
                                <TextField
                                    fullWidth
                                    type="number"
                                    name="quantidade" // Alterado para refletir o estoque

                                    // 1. Exibe o valor do estado. Se for 0 ou vazio, deixa o campo limpo para melhor UX.
                                    value={this.state.quantidade === 0 ? '' : this.state.quantidade}

                                    // 2. Intercepta, valida se é menor que 1 e salva como número
                                    onChange={(event) => {

                                        const quantidade = parseInt(event.target.value);

                                        this.setState({ quantidade: quantidade < 1 ? 1 : quantidade });

                                    }}

                                    // Garante que os botões de "setinha" do HTML (input type="number") respeitem o mínimo de 1
                                    inputProps={{ min: 1 }}

                                    variant="outlined"
                                    size="small"
                                    sx={inputStyle}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                    Preço de venda <span style={{ color: '#ef4444' }}>*</span>
                                </Typography>
                                <TextField
                                    fullWidth
                                    name="precoVenda"
                                    // 1. Exibe o número do state formatado em BRL (se for 0 ou vazio, mostra string vazia)
                                    value={precoVenda ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(precoVenda) : ""}

                                    // 2. Intercepta o evento, limpa a string transformando em número e chama o seu handle genérico
                                    onChange={(event) => {
                                        const rawValue = event.target.value;

                                        // Remove tudo que não for número
                                        const cleanValue = rawValue.replace(/\D/g, "");

                                        // Transforma em centavos (ex: "750" vira 7.5)
                                        const numberValue = cleanValue ? parseFloat(cleanValue) / 100 : 0;

                                        // Altera o valor do evento artificialmente antes de mandar para o seu método
                                        event.target.value = numberValue;

                                        // Dispara o seu handleInputChange original que só faz o setState
                                        this.handleInputChange(event);
                                    }}
                                    placeholder="R$ 0,00"
                                    variant="outlined"
                                    size="small"

                                    sx={inputStyle}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#475569' }}>
                                    Preço original <span style={{ color: '#94a3b8', fontWeight: 'normal' }}>(opcional)</span>
                                </Typography>
                                <TextField
                                    fullWidth
                                    name="precoOriginal"
                                    // 1. Exibe o número do state formatado em BRL (se for 0 ou vazio, mostra string vazia)
                                    value={precoOriginal ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(precoOriginal) : ""}

                                    // 2. Intercepta o evento, limpa a string transformando em número e chama o seu handle genérico
                                    onChange={(event) => {
                                        const rawValue = event.target.value;

                                        // Remove tudo que não for número
                                        const cleanValue = rawValue.replace(/\D/g, "");

                                        // Transforma em centavos (ex: "750" vira 7.5)
                                        const numberValue = cleanValue ? parseFloat(cleanValue) / 100 : 0;

                                        // Altera o valor do evento artificialmente antes de mandar para o seu método
                                        event.target.value = numberValue;

                                        // Dispara o seu handleInputChange original que só faz o setState
                                        this.handleInputChange(event);
                                    }}
                                    placeholder="R$ 0,00"
                                    variant="outlined"
                                    size="small"

                                    sx={inputStyle}
                                />
                            </Grid>
                        </Grid>

                        {/* Linha 2: Switch Preço sob consulta */}
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                bgcolor: '#f8fafc',
                                p: 1.5,
                                borderRadius: 2,
                                border: '1px solid #e2e8f0',
                                mb: 3
                            }}
                        >
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: '600', color: '#1e293b' }}>
                                    Preço sob consulta
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                    Clientes verão "Consulte o preço"
                                </Typography>
                            </Box>
                            <Switch
                                name="precoSobConsulta"
                                checked={precoSobConsulta}
                                onChange={this.handleSwitchChange}
                                color="secondary"
                                sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#7c3aed' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: '#7c3aed' } }}
                            />
                        </Box>

                        {/* Linha 3: Gatilho do Collapse (Configurar preço de atacado) */}
                        <Box sx={{ mb: 1 }}>
                            <Button
                                onClick={() => this.setState({ expandidoAtacado: !expandidoAtacado })}
                                disabled
                                startIcon={expandidoAtacado ? <ArrowUpIcon fontSize="small" /> : <ArrowDownIcon fontSize="small" />}
                                sx={{
                                    textTransform: 'none',
                                    color: '#64748b',
                                    fontWeight: '500',
                                    fontSize: '0.875rem',
                                    p: 0,
                                    '&:hover': { bgcolor: 'transparent', color: '#475569' }
                                }}
                            >
                                Configurar preço de atacado
                            </Button>
                        </Box>

                        {/* Seção Sanfonada do Atacado */}
                        <Collapse in={expandidoAtacado}>
                            <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 3, p: 2.5, mt: 1.5, bgcolor: '#fff' }}>

                                {/* Switch: Vender no Atacado */}
                                <Box sx={{ display: 'flex', justifyBetween: 'space-between', alignItems: 'center', mb: 2 }}>
                                    <Typography variant="body1" sx={{ fontWeight: '600', color: '#1e293b' }}>
                                        Vender no atacado?
                                    </Typography>
                                    <Switch
                                        name="venderAtacado"
                                        checked={venderAtacado}
                                        onChange={this.handleSwitchChange}
                                        sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#7c3aed' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: '#7c3aed' } }}
                                    />
                                </Box>

                                {/* Sub-bloco ativo baseado no "Vender no atacado?" */}
                                <Collapse in={venderAtacado}>
                                    <Divider sx={{ my: 2, borderColor: '#e2e8f0' }} />

                                    {/* Caixa informativa interna: Exibir apenas preço de Atacado */}
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            bgcolor: '#f8fafc',
                                            p: 1.5,
                                            borderRadius: 2,
                                            border: '1px solid #e2e8f0',
                                            mb: 3
                                        }}
                                    >
                                        <Box>
                                            <Typography variant="body2" sx={{ fontWeight: '600', color: '#1e293b' }}>
                                                Exibir apenas preço de atacado
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                                Produto vendido somente no atacado
                                            </Typography>
                                        </Box>
                                        <Switch
                                            name="exibirApenasAtacado"
                                            checked={exibirApenasAtacado}
                                            onChange={this.handleSwitchChange}
                                            size="small"
                                        />
                                    </Box>

                                    {/* Inputs de Valores do Atacado */}
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={4}>
                                            <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                                Preço atacado
                                            </Typography>
                                            <TextField
                                                fullWidth
                                                name="precoAtacado"
                                                value={precoAtacado}
                                                onChange={this.handleInputChange}
                                                placeholder="R$ 0,00"
                                                variant="outlined"
                                                size="small"
                                                sx={inputStyle}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                                Qtd. mínima
                                            </Typography>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                name="qtdMinima"
                                                value={qtdMinima}
                                                onChange={this.handleInputChange}
                                                variant="outlined"
                                                size="small"
                                                sx={inputStyle}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                                Unidade
                                            </Typography>
                                            <TextField
                                                select
                                                fullWidth
                                                name="unidade"
                                                value={unidade}
                                                onChange={this.handleInputChange}
                                                variant="outlined"
                                                size="small"
                                                sx={inputStyle}
                                            >
                                                <MenuItem value="UN">UN</MenuItem>
                                                <MenuItem value="PC">PC</MenuItem>
                                                <MenuItem value="KG">KG</MenuItem>
                                            </TextField>
                                        </Grid>
                                    </Grid>
                                </Collapse>

                            </Box>
                        </Collapse>

                    </CardContent>

                </Card>

                <VariacoesProduto listaDeVariacoes={this.state.variacoes} onVariacoesChange={(variacoes) => {
                    this.setState({ variacoes })
                }} />

                {/* ================= BOTÃO SALVAR ================= */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={() => {

                            var { nome, descricao, fotos, categoria, categorias, sku, marca, destaque, expandidoOpcional, quantidade, precoVenda, precoOriginal, variacoes } = this.state;



                            fetch(`${apiUrl}/products/set`, {
                                method: "POST",
                                credentials: "include",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                    uuid: this.props.params.uuid,
                                    nome,
                                    descricao,
                                    fotos,
                                    categoria,
                                    sku,
                                    marca,
                                    destaque,
                                    quantidade,
                                    precoVenda,
                                    precoOriginal,
                                    variacoes
                                }),
                            })
                                .then((response) => response.json())
                                .then((data) => {
                                    toast.success("Produto editado com sucesso!");
                                    this.props.navigate('/produtos');
                                })

                        }}
                        sx={{ textTransform: 'none', borderRadius: 2 }}

                    >
                        Salvar
                    </Button>
                </Box>

            </Box>
        );
    }
}

export default WithRouter(EditarProduto);